import { FC } from "react";
import { IconPropsType } from ".";

export const Location: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.08074 15.7138L12.5202 12.1413C15.0128 9.55229 14.8257 5.40277 12.1103 3.04853C9.75166 1.00357 6.24839 1.00356 3.88972 3.04851C1.17432 5.40275 0.987303 9.55227 3.47991 12.1412L6.91957 15.7139C7.50962 16.3267 8.4907 16.3267 9.08074 15.7138ZM2.90711 1.91516C-0.457428 4.83221 -0.689159 9.97371 2.39933 13.1816L5.83899 16.7542C7.01908 17.9799 8.98125 17.9799 10.1613 16.7542L13.6008 13.1816C16.6893 9.97371 16.4575 4.83221 13.0929 1.91518C10.1704 -0.618648 5.82965 -0.618663 2.90711 1.91516Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 9.5C9.10457 9.5 10 8.60457 10 7.5C10 6.39543 9.10457 5.5 8 5.5C6.89543 5.5 6 6.39543 6 7.5C6 8.60457 6.89543 9.5 8 9.5ZM8 11C9.933 11 11.5 9.433 11.5 7.5C11.5 5.567 9.933 4 8 4C6.067 4 4.5 5.567 4.5 7.5C4.5 9.433 6.067 11 8 11Z"
        fill={props.color}
      />
    </svg>
  );
};
